import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
let frequencyOptions = [];
let dayOfWeekOptions = [];

const PartnerSurveyAlertReadOnlyRow = ({ index, t, partnerSurveyAlertItem, handleDeleteClick, oddIdx, add, setError, handleSubmit }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const notCompletedRef = useRef(null);
    const [isNotCompleted, setIsNotCompleted] = useState(partnerSurveyAlertItem.notCompleted);
    const completedRef = useRef(null);
    const [isCompleted, setIsCompleted] = useState(partnerSurveyAlertItem.completed);
    const highScoreRef = useRef(null);
    const [isHighScore, setIsHighScore] = useState(partnerSurveyAlertItem.highScore);
    const takeCorrectiveActionRef = useRef(null);
    const [isTakeCorrectiveAction, setIsTakeCorrectiveAction] = useState(partnerSurveyAlertItem.takeCorrectiveAction);
    const completeCorrectiveActionRef = useRef(null);
    const [isCompleteCorrectiveAction, setIsCompleteCorrectiveAction] = useState(partnerSurveyAlertItem.completedCorrectiveAction);
    const freqRef = useRef(null);
    const [frequencySelected, setFrequencySelected] = useState({ name: "freq", label: "", value: "" });
    const dowRef = useRef(null);
    const [dayOfWeekSelected, setDayOfWeekSelected] = useState({ name: "dow", label: t("page.anyday"), value: 0 });

    useEffect(() => {
        setFrequencyValues();
        setDayOfWeekValues();
    }, []);

    function setFrequencyValues() {
        frequencyOptions = [];
        frequencyOptions.push({ "label": "", "value": "" });
        frequencyOptions.push({ "label": t("page.weekly"), "value": "week" });
        frequencyOptions.push({ "label": t("page.monthly"), "value": "month" });
        frequencyOptions.push({ "label": t("page.yearly"), "value": "year" });

        setFrequency();
    }

    const setFrequency = () => {
        let freqSelectValue = "";
        let freqSelectLabel = "";

        if (partnerSurveyAlertItem.weekly) {
            freqSelectLabel = t("page.weekly");
            freqSelectValue = "week";
        } else if (partnerSurveyAlertItem.monthly) {
            freqSelectLabel = t("page.monthly");
            freqSelectValue = "month";
        } else if (partnerSurveyAlertItem.yearly) {
            freqSelectLabel = t("page.yearly");
            freqSelectValue = "year";
        }
        setFrequencySelected({ ...frequencySelected, label: freqSelectLabel, value: freqSelectValue });
    }

    const freqHandler = (selectedOption, action) => {
        let freqValue = selectedOption ? selectedOption.value : 0;
        let freqLabel = selectedOption ? selectedOption.label : "";
        setFrequencySelected({ ...frequencySelected, label: freqLabel, value: freqValue });
    }

    function setDayOfWeekValues() {
        dayOfWeekOptions = [];
        dayOfWeekOptions.push({ "label": t("page.anyday"), "value": 0 });
        dayOfWeekOptions.push({ "label": t("page.mon"), "value": 2 });
        dayOfWeekOptions.push({ "label": t("page.tue"), "value": 3 });
        dayOfWeekOptions.push({ "label": t("page.wed"), "value": 4 });
        dayOfWeekOptions.push({ "label": t("page.thu"), "value": 5 });
        dayOfWeekOptions.push({ "label": t("page.fri"), "value": 6 });
        dayOfWeekOptions.push({ "label": t("page.sat"), "value": 7 });
        dayOfWeekOptions.push({ "label": t("page.sun"), "value": 1 });
        setDayOfWeek();
    }

    const setDayOfWeek = () => {
        let dowSelectValue = 0;
        let dowSelectLabel = "";

        switch (partnerSurveyAlertItem.dayOfWeek) {
            case 0: dowSelectLabel = t("page.anyday");
                dowSelectValue = 0;
                break;
            case 1: dowSelectLabel = t("page.sun");
                dowSelectValue = 1;
                break;
            case 2: dowSelectLabel = t("page.mon");
                dowSelectValue = 2;
                break;
            case 3: dowSelectLabel = t("page.tue");
                dowSelectValue = 3;
                break;
            case 4: dowSelectLabel = t("page.wed");
                dowSelectValue = 4;
                break;
            case 5: dowSelectLabel = t("page.thu");
                dowSelectValue = 5;
                break;
            case 6: dowSelectLabel = t("page.fri");
                dowSelectValue = 6;
                break;
            case 7: dowSelectLabel = t("page.sat");
                dowSelectValue = 7;
                break;

            default: dowSelectLabel = t("page.anyday");
                dowSelectValue = 0;
                break;
        }

        setDayOfWeekSelected({ ...dayOfWeekSelected, label: dowSelectLabel, value: dowSelectValue });
    }

    const dayOfWeekHandler = (selectedOption, action) => {
        let dowSelectValue = selectedOption ? selectedOption.value : 0;
        let dowSelectLabel = selectedOption ? selectedOption.label : t("page.anyday");
        setDayOfWeekSelected({ ...dayOfWeekSelected, label: dowSelectLabel, value: dowSelectValue });
    }

    function submitComplete() {
        setIsSubmit(false);
    }

    function submitDelete(event, partnerSurveyAlertItem) {
        setError("");
        setIsSubmit(true);
        handleDeleteClick(event, partnerSurveyAlertItem, submitComplete);
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        if (name.startsWith("notCompleted_")) {
            setIsNotCompleted(event.target.checked);
        } else if (name.startsWith("completed_")) {
            setIsCompleted(event.target.checked);
        } else if (name.startsWith("highScore_")) {
            setIsHighScore(event.target.checked);
        } else if (name.startsWith("completeCorrectiveAction_")) {
            setIsCompleteCorrectiveAction(event.target.checked);
        } else if (name.startsWith("takeCorrectiveAction_")) {
            setIsTakeCorrectiveAction(event.target.checked);
        }
    }

    function handleEditClick(event) {
        //event.preventDefault();
        //event.stopPropagation();
        setIsSubmit(false);
        setIsEditMode(true);
    }

    function submitUpdate(event, partnerSurveyAlertItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsSubmit(true);
        let freqSelect = frequencySelected.value;
        let dowSelect = dayOfWeekSelected.value;
        let updatedValues = {
            partnerKey: partnerSurveyAlertItem.partnerKey,
            appSurveyKey: partnerSurveyAlertItem.appSurveyKey,
            notCompleted: notCompletedRef.current.checked,
            completed: completedRef.current.checked,
            highScore: highScoreRef.current.checked,
            takeCorrectiveAction: takeCorrectiveActionRef.current.checked,
            completedCorrectiveAction: completeCorrectiveActionRef.current.checked,
            dayOfWeek: dowSelect,
            weekly: (freqSelect === "week") ? true : false,
            monthly: (freqSelect === "month") ? true : false,
            yearly: (freqSelect === "year") ? true : false,
        };
        handleSubmit(2, updatedValues, submitUpdateComplete);
    }
    function submitUpdateComplete() {
        setIsSubmit(false);
        setIsEditMode(false);
    }
    function submitCancel(event, partnerSurveyAlertItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsNotCompleted(partnerSurveyAlertItem.notCompleted);
        setIsCompleted(partnerSurveyAlertItem.completed);
        setIsHighScore(partnerSurveyAlertItem.highScore);
        setIsCompleteCorrectiveAction(partnerSurveyAlertItem.completedCorrectiveAction);
        setIsTakeCorrectiveAction(partnerSurveyAlertItem.takeCorrectiveAction);
        setFrequency();
        setDayOfWeek();
        setIsEditMode(false);
        setIsSubmit(false);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerSurveyAlertItem.surveyDisplayName}</td>
            {isEditMode ? (
                <>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <Select
                            ref={freqRef}
                            name="freq"
                            options={frequencyOptions}
                            onChange={freqHandler}
                            placeholder={""}
                            value={frequencySelected}
                            isSearchable={true}
                            isClearable={true}
                            className="myselect"
                            inputId="freq-input"
                            styles={ddStyles}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <Select
                            ref={dowRef}
                            name="dow"
                            options={dayOfWeekOptions}
                            onChange={dayOfWeekHandler}
                            placeholder={""}
                            value={dayOfWeekSelected}
                            isSearchable={true}
                            isClearable={true}
                            className="myselect"
                            inputId="dow-input"
                            styles={ddStyles}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={notCompletedRef}
                            name={"notCompleted_" + partnerSurveyAlertItem.appSurveyKey}
                            id={"notCompleted_" + partnerSurveyAlertItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isNotCompleted}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={completedRef}
                            name={"completed_" + partnerSurveyAlertItem.appSurveyKey}
                            id={"completed_" + partnerSurveyAlertItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isCompleted}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={highScoreRef}
                            name={"highScore_" + partnerSurveyAlertItem.appSurveyKey}
                            id={"highScore_" + partnerSurveyAlertItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isHighScore}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={takeCorrectiveActionRef}
                            name={"takeCorrectiveAction_" + partnerSurveyAlertItem.appSurveyKey}
                            id={"takeCorrectiveAction_" + partnerSurveyAlertItem.appSurveyKey}
                            defaultChecked={false}
                            checked={isTakeCorrectiveAction}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={completeCorrectiveActionRef}
                            name={"completeCorrectiveAction_" + partnerSurveyAlertItem.appSurveyKey}
                            id={"completeCorrectiveAction_" + partnerSurveyAlertItem.appSurveyKey}
                            defaultChecked={false}
                            checked={isCompleteCorrectiveAction}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerSurveyAlertItem.status}</td>
                </>
            ) : (
                <>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{frequencySelected.label}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{dayOfWeekSelected.label}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyAlertItem.notCompleted}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyAlertItem.completed}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyAlertItem.highScore}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyAlertItem.takeCorrectiveAction}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerSurveyAlertItem.completedCorrectiveAction}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerSurveyAlertItem.status}</td>
                </>
            )}

            <td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {isEditMode ? (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
                            onClick={(event) => submitUpdate(event, partnerSurveyAlertItem)}>{t("page.submit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
                            onClick={(event) => (submitCancel(event, partnerSurveyAlertItem))}>{t("page.cancel")}</button>
                    </>
                ) : (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
                            onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, partnerSurveyAlertItem)}>
                            {partnerSurveyAlertItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
                    </>
                )}
            </td>
        </tr>
    )
}
export default PartnerSurveyAlertReadOnlyRow;